

// // import React, { useEffect, useState } from "react";
// // import axios from "axios";
// // import {
// //   Chart as ChartJS,
// //   CategoryScale,
// //   LinearScale,
// //   PointElement,
// //   LineElement,
// //   Title,
// //   Tooltip,
// //   Legend,
// // } from "chart.js";
// // import { Line } from "react-chartjs-2";
// // import "./PriceAnalytics.css";

// // ChartJS.register(
// //   CategoryScale,
// //   LinearScale,
// //   PointElement,
// //   LineElement,
// //   Title,
// //   Tooltip,
// //   Legend
// // );

// // const API_BASE = "https://grocerrybackend.vercel.app/api";

// // const PriceAnalytics = () => {
// //   const [loading, setLoading] = useState(true);
// //   const [productList, setProductList] = useState([]);
// //   const [categoryList, setCategoryList] = useState([]);
// //   const [selectedProduct, setSelectedProduct] = useState("");
// //   const [selectedCategory, setSelectedCategory] = useState("");
// //   const [startDate, setStartDate] = useState("");
// //   const [endDate, setEndDate] = useState("");
// //   const [chartData, setChartData] = useState(null);

// //   // 🔹 Fetch dropdowns
// //   useEffect(() => {
// //     const fetchDropdowns = async () => {
// //       try {
// //         const [products, categories] = await Promise.all([
// //           axios.get(`${API_BASE}/prices`),
// //           axios.get(`${API_BASE}/categories`),
// //         ]);
// //         setProductList(products.data.data || []);
// //         setCategoryList(categories.data.categories || []);
// //       } catch (err) {
// //         console.error("Dropdown fetch error:", err);
// //       }
// //     };
// //     fetchDropdowns();
// //   }, []);

// //   // 🔹 Fetch chart data with date filter
// //   const fetchChart = async () => {
// //     setLoading(true);
// //     try {
// //       const res = await axios.get(`${API_BASE}/prices`);
// //       const allPrices = res.data.data || [];

// //       // ✅ Filter by Product / Category
// //       let filtered = allPrices;
// //       if (selectedProduct)
// //         filtered = filtered.filter((p) => p.name === selectedProduct);
// //       if (selectedCategory)
// //         filtered = filtered.filter(
// //           (p) => p.category?.name === selectedCategory
// //         );

// //       // ✅ Filter by Date Range
// //       if (startDate && endDate) {
// //         const start = new Date(startDate);
// //         const end = new Date(endDate);

// //         filtered = filtered.filter((item) => {
// //           const date = new Date(item.validTill || item.createdAt);
// //           return date >= start && date <= end;
// //         });
// //       }

// //       // ✅ Group by Date
// //       const groupedByDate = {};
// //       filtered.forEach((item) => {
// //         const dateKey = new Date(
// //           item.validTill || item.createdAt
// //         ).toLocaleDateString("en-IN");

// //         if (!groupedByDate[dateKey]) groupedByDate[dateKey] = [];
// //         groupedByDate[dateKey].push(item);
// //       });

// //       const labels = Object.keys(groupedByDate);

// //       const avgBasePrice = labels.map((d) => {
// //         const dayData = groupedByDate[d];
// //         return (
// //           dayData.reduce((sum, i) => sum + Number(i.basePrice || 0), 0) /
// //           dayData.length
// //         );
// //       });

// //       const avgDiff = labels.map((d) => {
// //         const dayData = groupedByDate[d];
// //         return (
// //           dayData.reduce((sum, i) => sum + Number(i.difference || 0), 0) /
// //           dayData.length
// //         );
// //       });

// //       const totalCount = labels.map((d) => groupedByDate[d].length);

// //       // 🔹 Multiple Line Datasets
// //       setChartData({
// //         labels,
// //         datasets: [
// //           {
// //             label: "Average Base Price (₹)",
// //             data: avgBasePrice,
// //             borderColor: "#007bff",
// //             backgroundColor: "rgba(0,123,255,0.3)",
// //             tension: 0.3,
// //             fill: false,
// //           },
// //           {
// //             label: "Average Difference (₹)",
// //             data: avgDiff,
// //             borderColor: "#ffc107",
// //             backgroundColor: "rgba(255,193,7,0.3)",
// //             tension: 0.3,
// //             fill: false,
// //           },
// //           {
// //             label: "Total Products Count",
// //             data: totalCount,
// //             borderColor: "#28a745",
// //             backgroundColor: "rgba(40,167,69,0.3)",
// //             tension: 0.3,
// //             fill: false,
// //           },
// //         ],
// //       });
// //     } catch (err) {
// //       console.error("Chart fetch error:", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchChart();
// //   }, [selectedProduct, selectedCategory, startDate, endDate]);

// //   return (
// //     <div className="analytics-container">
// //       <h2 className="analytics-title">📅 Price History & Analytics</h2>
// //       <p className="analytics-subtitle">
// //         Track your product & category price trends over time
// //       </p>

// //       {/* Filters */}
// //       <div className="filter-section">
// //         <div className="filter-group">
// //           <label>🧃 Product:</label>
// //           <select value={selectedProduct} onChange={(e) => setSelectedProduct(e.target.value)}>
// //             <option value="">All Products</option>
// //             {productList.map((p) => (
// //               <option key={p._id} value={p.name}>{p.name}</option>
// //             ))}
// //           </select>
// //         </div>

// //         <div className="filter-group">
// //           <label>🗂️ Category:</label>
// //           <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
// //             <option value="">All Categories</option>
// //             {categoryList.map((c) => (
// //               <option key={c._id} value={c.name}>{c.name}</option>
// //             ))}
// //           </select>
// //         </div>

// //         <div className="filter-group">
// //           <label>📆 From:</label>
// //           <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
// //         </div>

// //         <div className="filter-group">
// //           <label>➡ To:</label>
// //           <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
// //         </div>

// //         <button className="btn refresh" onClick={fetchChart}>🔄 Apply</button>
// //       </div>

// //       {/* Chart */}
// //       <div className="chart-wrapper">
// //         {loading ? (
// //           <div className="loading">Loading chart...</div>
// //         ) : chartData ? (
// //           <Line
// //             data={chartData}
// //             options={{
// //               responsive: true,
// //               maintainAspectRatio: false,
// //               plugins: {
// //                 legend: { position: "bottom" },
// //               },
// //               scales: {
// //                 y: { beginAtZero: true },
// //               },
// //             }}
// //           />
// //         ) : (
// //           <div className="no-data">No data found.</div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default PriceAnalytics;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Line } from "react-chartjs-2";
// import "./PriceAnalytics.css";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// const API_BASE = "https://grocerrybackend.vercel.app/api";

// const PriceAnalytics = () => {
//   const [loading, setLoading] = useState(true);
//   const [productList, setProductList] = useState([]);
//   const [categoryList, setCategoryList] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [chartData, setChartData] = useState(null);

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const [p, c] = await Promise.all([
//           axios.get(`${API_BASE}/prices`),
//           axios.get(`${API_BASE}/categories`),
//         ]);

//         setProductList(p.data.data || []);
//         setCategoryList(c.data.categories || []);
//       } catch (err) {
//         console.error("Dropdown fetch error:", err);
//       }
//     };

//     fetchDropdowns();
//   }, []);

//   const fetchChart = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.get(`${API_BASE}/prices`);
//       let all = res.data.data || [];

//       // Filters
//       if (selectedProduct)
//         all = all.filter((p) => p.name === selectedProduct);

//       if (selectedCategory)
//         all = all.filter((p) => p.category?.name === selectedCategory);

//       // Group by Date
//       const grouped = {};
//       all.forEach((item) => {
//         const k = new Date(item.validTill || item.createdAt).toLocaleDateString("en-IN");
//         if (!grouped[k]) grouped[k] = [];
//         grouped[k].push(item);
//       });

//       const labels = Object.keys(grouped);

//       // Final Price
//       const finalPrice = labels.map((d) => {
//         const arr = grouped[d];
//         return arr.reduce(
//           (sum, x) => sum + (Number(x.basePrice || 0) + Number(x.difference || 0)),
//           0
//         ) / arr.length;
//       });

//       setChartData({
//         labels,
//         datasets: [
//           {
//             label: "Final Price (₹)",
//             data: finalPrice,
//             borderColor: "#007bff",
//             backgroundColor: "rgba(0,123,255,0.3)",
//             tension: 0.3,
//           },
//         ],
//       });
//     } catch (err) {
//       console.error("Chart error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchChart();
//   }, [selectedProduct, selectedCategory]);

//   return (
//     <div className="analytics-container">
//       <h2 className="analytics-title">📊 Final Price Analytics</h2>

//       {/* Filters */}
//       <div className="filter-section">
//         <select value={selectedProduct} onChange={(e) => setSelectedProduct(e.target.value)}>
//           <option value="">All Products</option>
//           {productList.map((p) => (
//             <option key={p._id} value={p.name}>{p.name}</option>
//           ))}
//         </select>

//         <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
//           <option value="">All Categories</option>
//           {categoryList.map((c) => (
//             <option key={c._id} value={c.name}>{c.name}</option>
//           ))}
//         </select>

//         <button className="btn refresh" onClick={fetchChart}>Apply</button>
//       </div>

//       {/* Chart */}
//       <div className="chart-wrapper">
//         {loading ? (
//           <div className="loading">Loading...</div>
//         ) : (
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               plugins: {
//                 legend: { position: "bottom" },

//                 // ⭐ ALWAYS SHOW LABEL ⭐
//                 datalabels: {
//                   color: "#000",
//                   anchor: "end",
//                   align: "top",
//                   formatter: (value) => `₹${value}`,
//                   font: {
//                     weight: "bold",
//                     size: 12,
//                   },
//                 },
//               },
//               scales: {
//                 y: { beginAtZero: true },
//               },
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default PriceAnalytics;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Line } from "react-chartjs-2";
// import "./PriceAnalytics.css";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// const API_BASE = "https://grocerrybackend.vercel.app/api";

// const PriceAnalytics = () => {
//   const [loading, setLoading] = useState(true);
//   const [productList, setProductList] = useState([]);
//   const [categoryList, setCategoryList] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");

//   // NEW FILTER STATE
//   const [chartType, setChartType] = useState("daily"); // daily, weekly, monthly, yearly, custom
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const [chartData, setChartData] = useState(null);

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const [p, c] = await Promise.all([
//           axios.get(`${API_BASE}/prices`),
//           axios.get(`${API_BASE}/categories`),
//         ]);

//         setProductList(p.data.data || []);
//         setCategoryList(c.data.categories || []);
//       } catch (err) {
//         console.error("Dropdown fetch error:", err);
//       }
//     };

//     fetchDropdowns();
//   }, []);

//   // 🔥 GROUPING HELPERS
//   const groupByWeek = (date) => {
//     const d = new Date(date);
//     const onejan = new Date(d.getFullYear(), 0, 1);
//     const week = Math.ceil(((d - onejan) / 86400000 + onejan.getDay() + 1) / 7);
//     return `Week ${week} - ${d.getFullYear()}`;
//   };

//   const groupByMonth = (date) => {
//     const d = new Date(date);
//     return `${d.toLocaleString("en-US", { month: "short" })} ${d.getFullYear()}`;
//   };

//   const groupByYear = (date) => {
//     return new Date(date).getFullYear().toString();
//   };

//   const fetchChart = async () => {
//     setLoading(true);

//     try {
//       const res = await axios.get(`${API_BASE}/prices`);
//       let all = res.data.data || [];

//       // PRODUCT FILTER
//       if (selectedProduct)
//         all = all.filter((p) => p.name === selectedProduct);

//       // CATEGORY FILTER
//       if (selectedCategory)
//         all = all.filter((p) => p.category?.name === selectedCategory);

//       // RANGE FILTER
//       if (chartType === "custom" && startDate && endDate) {
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         all = all.filter((p) => {
//           const d = new Date(p.validTill || p.createdAt);
//           return d >= start && d <= end;
//         });
//       }

//       // GROUP DATA
//       const groups = {};

//       all.forEach((item) => {
//         const date = item.validTill || item.createdAt;

//         let groupKey = "";

//         switch (chartType) {
//           case "weekly":
//             groupKey = groupByWeek(date);
//             break;
//           case "monthly":
//             groupKey = groupByMonth(date);
//             break;
//           case "yearly":
//             groupKey = groupByYear(date);
//             break;
//           default:
//             groupKey = new Date(date).toLocaleDateString("en-IN");
//         }

//         if (!groups[groupKey]) groups[groupKey] = [];
//         groups[groupKey].push(item);
//       });

//       const labels = Object.keys(groups);

//       const finalPriceAvg = labels.map((d) => {
//         const arr = groups[d];
//         return (
//           arr.reduce(
//             (sum, x) =>
//               sum + (Number(x.basePrice || 0) + Number(x.difference || 0)),
//             0
//           ) / arr.length
//         );
//       });

//       setChartData({
//         labels,
//         datasets: [
//           {
//             label: "Final Price (₹)",
//             data: finalPriceAvg,
//             borderColor: "#007bff",
//             backgroundColor: "rgba(0,123,255,0.3)",
//             tension: 0.3,
//           },
//         ],
//       });
//     } catch (err) {
//       console.error("Chart Error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchChart();
//   }, [selectedProduct, selectedCategory, chartType, startDate, endDate]);

//   return (
//     <div className="analytics-container">
//       <h2 className="analytics-title">Price Analytics</h2>

//       <div className="filter-section">
        
//         {/* PRODUCT */}
//         <select value={selectedProduct} onChange={(e) => setSelectedProduct(e.target.value)}>
//           <option value="">All Products</option>
//           {productList.map((p) => (
//             <option key={p._id} value={p.name}>{p.name}</option>
//           ))}
//         </select>

//         {/* CATEGORY */}
//         <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
//           <option value="">All Categories</option>
//           {categoryList.map((c) => (
//             <option key={c._id} value={c.name}>{c.name}</option>
//           ))}
//         </select>

//         {/* TYPE FILTER */}
//         <select value={chartType} onChange={(e) => setChartType(e.target.value)}>
//           <option value="daily">Daily</option>
//           <option value="weekly">Weekly</option>
//           <option value="monthly">Monthly</option>
//           <option value="yearly">Yearly</option>
//           <option value="custom">Custom Range</option>
//         </select>

//         {/* DATE RANGE ONLY IF CUSTOM */}
//         {chartType === "custom" && (
//           <>
//             <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
//             <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
//           </>
//         )}

//         {/* <button className="btn refresh" onClick={fetchChart}>Apply</button> */}
//       </div>

//       <div className="chart-wrapper">
//         {loading ? (
//           <div className="loading">Loading chart...</div>
//         ) : (
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               plugins: {
//                 legend: { position: "bottom" },
//                 datalabels: {
//                   color: "black",
//                   anchor: "end",
//                   align: "top",
//                   formatter: (v) => `₹${v}`,
//                   font: { size: 12, weight: "bold" },
//                 },
//               },
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default PriceAnalytics;




// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Line } from "react-chartjs-2";
// import "./PriceAnalytics.css"; // Assuming you will define the custom CSS here

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   ChartDataLabels
// );

// const API_BASE = "https://grocerrybackend.vercel.app/api";

// // Define a color palette for visualization
// const chartColors = {
//   linePrimary: "#007bff", // Blue
//   lineBackground: "rgba(0, 123, 255, 0.2)",
//   labels: "#212529", // Dark Text
// };

// const PriceAnalytics = () => {
//   const [loading, setLoading] = useState(true);
//   const [productList, setProductList] = useState([]);
//   const [categoryList, setCategoryList] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");

//   const [chartType, setChartType] = useState("daily"); // daily, weekly, monthly, yearly, custom
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const [chartData, setChartData] = useState(null);

//   /**
//    * 🛍️ Fetch Dropdown Data (Products and Categories)
//    */
//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const [p, c] = await Promise.all([
//           axios.get(`${API_BASE}/products`), // Changed to products for better product list
//           axios.get(`${API_BASE}/categories`),
//         ]);

//         // Assuming products endpoint returns an array of objects with a 'name' property
//         setProductList(p.data.data || []);
//         setCategoryList(c.data.categories || []);
//       } catch (err) {
//         console.error("Dropdown fetch error:", err);
//       }
//     };

//     fetchDropdowns();
//   }, []);

//   /**
//    * 📅 Grouping Helpers
//    */
//   const groupByWeek = (date) => {
//     const d = new Date(date);
//     // Standard JS week number calculation
//     const startOfYear = new Date(d.getFullYear(), 0, 1);
//     const dayCount = Math.floor((d - startOfYear) / (24 * 60 * 60 * 1000));
//     const week = Math.ceil((dayCount + 1 + startOfYear.getDay()) / 7);
//     return `Week ${week} - ${d.getFullYear()}`;
//   };

//   const groupByMonth = (date) => {
//     const d = new Date(date);
//     return `${d.toLocaleString("en-US", { month: "short" })} ${d.getFullYear()}`;
//   };

//   const groupByYear = (date) => {
//     return new Date(date).getFullYear().toString();
//   };

//   /**
//    * 📈 Fetch and Process Chart Data
//    */
//   const fetchChart = async () => {
//     setLoading(true);

//     try {
//       // NOTE: Using a single endpoint that returns all price history data
//       const res = await axios.get(`${API_BASE}/prices`);
//       let all = res.data.data || [];

//       // --- 1. APPLY FILTERS ---

//       // PRODUCT FILTER
//       if (selectedProduct)
//         all = all.filter((p) => p.name === selectedProduct);

//       // CATEGORY FILTER
//       if (selectedCategory)
//         all = all.filter((p) => p.category?.name === selectedCategory);

//       // RANGE FILTER (for custom chart type)
//       if (chartType === "custom" && startDate && endDate) {
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         end.setDate(end.getDate() + 1); // Include the end date fully
//         all = all.filter((p) => {
//           const d = new Date(p.validTill || p.createdAt);
//           return d >= start && d <= end;
//         });
//       }

//       // --- 2. GROUP DATA ---
//       const groups = {};

//       all.forEach((item) => {
//         const date = item.validTill || item.createdAt;

//         let groupKey = "";

//         switch (chartType) {
//           case "weekly":
//             groupKey = groupByWeek(date);
//             break;
//           case "monthly":
//             groupKey = groupByMonth(date);
//             break;
//           case "yearly":
//             groupKey = groupByYear(date);
//             break;
//           default:
//             // Daily
//             groupKey = new Date(date).toLocaleDateString("en-IN");
//         }

//         if (!groups[groupKey]) groups[groupKey] = [];
//         groups[groupKey].push(item);
//       });

//       // --- 3. CALCULATE AVERAGE PRICE ---

//       const labels = Object.keys(groups).sort(); // Sort labels chronologically

//       const finalPriceAvg = labels.map((d) => {
//         const arr = groups[d];
//         const sumOfPrices = arr.reduce(
//           (sum, x) =>
//             sum + (Number(x.basePrice || 0) + Number(x.difference || 0)),
//           0
//         );
//         // Round to 2 decimal places for currency display
//         return Math.round((sumOfPrices / arr.length) * 100) / 100;
//       });

//       setChartData({
//         labels,
//         datasets: [
//           {
//             label: "Average Price (₹)",
//             data: finalPriceAvg,
//             borderColor: chartColors.linePrimary,
//             backgroundColor: chartColors.lineBackground,
//             pointBackgroundColor: chartColors.linePrimary,
//             pointBorderColor: "#fff",
//             pointHoverBackgroundColor: "#fff",
//             pointHoverBorderColor: chartColors.linePrimary,
//             borderWidth: 3,
//             tension: 0.4, // Smoother line
//             fill: true, // Fill area under the line
//           },
//         ],
//       });
//     } catch (err) {
//       console.error("Chart Error:", err);
//       setChartData(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchChart();
//   }, [selectedProduct, selectedCategory, chartType, startDate, endDate]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     scales: {
//       y: {
//         beginAtZero: false,
//         title: {
//           display: true,
//           text: "Average Price (₹)",
//           color: chartColors.labels,
//           font: { weight: "bold" },
//         },
//       },
//     },
//     plugins: {
//       title: {
//         display: true,
//         text: selectedProduct
//           ? `${selectedProduct} Price History`
//           : "Overall Price Trend",
//         font: { size: 18, weight: "bold" },
//         color: chartColors.labels,
//       },
//       legend: { position: "top" },
//       tooltip: {
//         mode: "index",
//         intersect: false,
//       },
//       datalabels: {
//         color: chartColors.linePrimary,
//         anchor: "end",
//         align: "top",
//         formatter: (v) => (v ? `₹${v.toFixed(2)}` : ""),
//         font: { size: 12, weight: "bold" },
//       },
//     },
//   };

//   return (
//     <div className="analytics-container">
//       <h2 className="analytics-title">📊 Price Analytics Dashboard</h2>

//       <div className="filter-section">
        
//         {/* PRODUCT Filter */}
//         <select 
//           className="analytics-select"
//           value={selectedProduct} 
//           onChange={(e) => setSelectedProduct(e.target.value)}
//         >
//           <option value="">All Products</option>
//           {productList.map((p) => (
//             <option key={p._id} value={p.name}>{p.name}</option>
//           ))}
//         </select>

//         {/* CATEGORY Filter */}
//         <select 
//           className="analytics-select"
//           value={selectedCategory} 
//           onChange={(e) => setSelectedCategory(e.target.value)}
//         >
//           <option value="">All Categories</option>
//           {categoryList.map((c) => (
//             <option key={c._id} value={c.name}>{c.name}</option>
//           ))}
//         </select>

//         {/* TIME GROUPING Filter */}
//         <select 
//           className="analytics-select time-group"
//           value={chartType} 
//           onChange={(e) => setChartType(e.target.value)}
//         >
//           <option value="daily">Group by Day</option>
//           <option value="weekly">Group by Week</option>
//           <option value="monthly">Group by Month</option>
//           <option value="yearly">Group by Year</option>
//           <option value="custom">Custom Date Range</option>
//         </select>

//         {/* DATE RANGE ONLY IF CUSTOM */}
//         {chartType === "custom" && (
//           <div className="custom-dates">
//             <label>Start Date:</label>
//             <input 
//               type="date" 
//               className="analytics-input"
//               value={startDate} 
//               onChange={(e) => setStartDate(e.target.value)} 
//             />
//             <label>End Date:</label>
//             <input 
//               type="date" 
//               className="analytics-input"
//               value={endDate} 
//               onChange={(e) => setEndDate(e.target.value)} 
//             />
//           </div>
//         )}
//       </div>

//       <div className="chart-wrapper">
//         {loading ? (
//           <div className="loading">Loading chart data...</div>
//         ) : chartData && chartData.labels.length > 0 ? (
//           <Line
//             data={chartData}
//             options={chartOptions}
//           />
//         ) : (
//             <div className="no-data-message">
//                 😔 No price data found for the selected filters.
//             </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PriceAnalytics;


















import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";
import "./PriceAnalytics.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const API_BASE = "https://grocerrybackend.vercel.app/api";

// Define a color palette for visualization
const chartColors = {
  linePrimary: "#007bff", // Blue
  lineBackground: "rgba(0, 123, 255, 0.2)",
  labels: "#212529", // Dark Text
};

const PriceAnalytics = () => {
  const [loading, setLoading] = useState(true);
  const [productList, setProductList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const [chartType, setChartType] = useState("daily"); // daily, weekly, monthly, yearly, custom
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [p, c] = await Promise.all([
          axios.get(`${API_BASE}/prices`),
          axios.get(`${API_BASE}/categories`),
        ]);

        setProductList(p.data.data || []);
        setCategoryList(c.data.categories || []);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdowns();
  }, []);

  // 🔥 GROUPING HELPERS (from first code)
  const groupByWeek = (date) => {
    const d = new Date(date);
    const onejan = new Date(d.getFullYear(), 0, 1);
    const week = Math.ceil(((d - onejan) / 86400000 + onejan.getDay() + 1) / 7);
    return `Week ${week} - ${d.getFullYear()}`;
  };

  const groupByMonth = (date) => {
    const d = new Date(date);
    return `${d.toLocaleString("en-US", { month: "short" })} ${d.getFullYear()}`;
  };

  const groupByYear = (date) => {
    return new Date(date).getFullYear().toString();
  };

  const fetchChart = async () => {
    setLoading(true);

    try {
      const res = await axios.get(`${API_BASE}/prices`);
      let all = res.data.data || [];

      // PRODUCT FILTER (from first code)
      if (selectedProduct)
        all = all.filter((p) => p.name === selectedProduct);

      // CATEGORY FILTER (from first code)
      if (selectedCategory)
        all = all.filter((p) => p.category?.name === selectedCategory);

      // RANGE FILTER (from first code with improvements from second code)
      if (chartType === "custom" && startDate && endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setDate(end.getDate() + 1); // Include the end date fully (from second code)
        all = all.filter((p) => {
          const d = new Date(p.validTill || p.createdAt);
          return d >= start && d <= end;
        });
      }

      // GROUP DATA (from first code with sorting from second code)
      const groups = {};

      all.forEach((item) => {
        const date = item.validTill || item.createdAt;

        let groupKey = "";

        switch (chartType) {
          case "weekly":
            groupKey = groupByWeek(date);
            break;
          case "monthly":
            groupKey = groupByMonth(date);
            break;
          case "yearly":
            groupKey = groupByYear(date);
            break;
          default:
            groupKey = new Date(date).toLocaleDateString("en-IN");
        }

        if (!groups[groupKey]) groups[groupKey] = [];
        groups[groupKey].push(item);
      });

      const labels = Object.keys(groups).sort(); // Sort labels chronologically (from second code)

      const finalPriceAvg = labels.map((d) => {
        const arr = groups[d];
        const sumOfPrices = arr.reduce(
          (sum, x) =>
            sum + (Number(x.basePrice || 0) + Number(x.difference || 0)),
          0
        );
        // Round to 2 decimal places for currency display (from second code)
        return Math.round((sumOfPrices / arr.length) * 100) / 100;
      });

      setChartData({
        labels,
        datasets: [
          {
            label: "Final Price (₹)", // Keep label from first code
            data: finalPriceAvg,
            borderColor: chartColors.linePrimary, // Style from second code
            backgroundColor: chartColors.lineBackground, // Style from second code
            pointBackgroundColor: chartColors.linePrimary, // Style from second code
            pointBorderColor: "#fff", // Style from second code
            pointHoverBackgroundColor: "#fff", // Style from second code
            pointHoverBorderColor: chartColors.linePrimary, // Style from second code
            borderWidth: 3, // Style from second code
            tension: 0.4, // Smoother line from second code
            fill: true, // Fill area under the line from second code
          },
        ],
      });
    } catch (err) {
      console.error("Chart Error:", err);
      setChartData(null); // Set to null on error from second code
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChart();
  }, [selectedProduct, selectedCategory, chartType, startDate, endDate]);

  // Chart options with styling from second code but keeping data labels functionality from first code
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: "Price (₹)", // Simplified from second code
          color: chartColors.labels,
          font: { weight: "bold" },
        },
      },
    },
    plugins: {
      title: {
        display: true,
        text: selectedProduct
          ? `${selectedProduct} Price History`
          : "Price Trend", // Title from second code
        font: { size: 18, weight: "bold" },
        color: chartColors.labels,
      },
      legend: { 
        position: "bottom" // Position from first code
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      datalabels: {
        color: "black", // Color from first code
        anchor: "end", // From first code
        align: "top", // From first code
        formatter: (v) => `₹${v}`, // Formatter from first code
        font: { size: 12, weight: "bold" }, // From first code
      },
    },
  };

  return (
    <div className="analytics-container">
      <h2 className="analytics-title">Price Analytics</h2> {/* Title from first code */}

      <div className="filter-section">
        
        {/* PRODUCT Filter with styling from second code */}
        <select 
          className="analytics-select"
          value={selectedProduct} 
          onChange={(e) => setSelectedProduct(e.target.value)}
        >
          <option value="">All Products</option>
          {productList.map((p) => (
            <option key={p._id} value={p.name}>{p.name}</option>
          ))}
        </select>

        {/* CATEGORY Filter with styling from second code */}
        <select 
          className="analytics-select"
          value={selectedCategory} 
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          {categoryList.map((c) => (
            <option key={c._id} value={c.name}>{c.name}</option>
          ))}
        </select>

        {/* TIME GROUPING Filter with styling from second code */}
        <select 
          className="analytics-select time-group"
          value={chartType} 
          onChange={(e) => setChartType(e.target.value)}
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
          <option value="custom">Custom Range</option>
        </select>

        {/* DATE RANGE ONLY IF CUSTOM - with styling from second code */}
        {chartType === "custom" && (
          <>
            <input 
              type="date" 
              className="analytics-input"
              value={startDate} 
              onChange={(e) => setStartDate(e.target.value)} 
            />
            <input 
              type="date" 
              className="analytics-input"
              value={endDate} 
              onChange={(e) => setEndDate(e.target.value)} 
            />
          </>
        )}

        {/* Refresh button removed as per first code (auto-refresh on filter change) */}
      </div>

      <div className="chart-wrapper">
        {loading ? (
          <div className="loading">Loading chart...</div> 
        ) : chartData && chartData.labels.length > 0 ? (
          <Line
            data={chartData}
            options={chartOptions}
          />
        ) : (
          <div className="no-data-message">
            No price data found for the selected filters.
          </div>
        )}
      </div>
    </div>
  );
};

export default PriceAnalytics;